/*** npm vendor js ***/
import materialize from 'materialize-css';

/*** Common code ***/
require('../js/common/jquery-fn.js');
require('../js/partials/navbar');
require('../js/partials/pullup');
require('../js/partials/lazy');
require('../js/partials/form');
require('../js/partials/roas');


// WEBPACK FOOTER //
// ./src/common.js